import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";
import { toast } from "react-toastify";

const useTimeslotData = (handleDeleteClick, handleEditClick, refresh) => {
  const [rows, setRows] = useState([]);
  const [count, setcount] = useState(0);

  const columns = [
    { name: "sno", align: "center" },
    { name: "Start Time", align: "center" },
    { name: "End Time", align: "center" },
    { name: "action", align: "center" },
  ];

  useEffect(() => {
    axios
      .get(`${baseURL}/slots`)
      .then((res) => {
        // Normalize various possible response shapes
        const d = res.data;
        let slotsData = [];
        if (Array.isArray(d)) slotsData = d;
        else if (Array.isArray(d?.data)) slotsData = d.data;
        else if (Array.isArray(d?.data?.slots)) slotsData = d.data.slots;
        else if (Array.isArray(d?.slots)) slotsData = d.slots;
        else if (Array.isArray(d?.data?.data)) slotsData = d.data.data;

        // Filter deleted if isDeleted flag provided
        const visible = (slotsData || []).filter((s) => !s?.isDeleted);
        setcount(visible.length);
        if (!visible.length) {
          setRows([]);
          return;
        }

        const formattedRows = visible.map((slot, index) => ({
          sno: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {index + 1}
            </ArgonTypography>
          ),
          "Start Time": (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {slot?.startTime ?? "-"}
            </ArgonTypography>
          ),
          "End Time": (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {slot?.endTime ?? "-"}
            </ArgonTypography>
          ),
          action: (
            <ArgonBox display="flex" alignItems="center" gap={0}>
              <ArgonButton
                variant="text"
                size="large"
                sx={{ minWidth: "12px", p: 0 }}
                onClick={() => handleEditClick(slot?._id, slot?.startTime, slot?.endTime)}
              >
                <EditIcon color="warning" />
              </ArgonButton>

              <ArgonButton
                variant="text"
                size="large"
                sx={{ minWidth: "32px", p: 0 }}
                onClick={() => handleDeleteClick(slot?._id)}
              >
                <DeleteIcon color="error" />
              </ArgonButton>
            </ArgonBox>
          ),
        }));

        setRows(formattedRows);
      })
      .catch((err) => {
        console.error("❌ Error fetching timeslots:", err);
        toast.error(err.response?.data?.error || "Failed to load timeslots");
      });
  }, [refresh]);

  return { columns, rows, count };
};

export default useTimeslotData;
